
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_1wepg_mrt2a_93",
  "description": "awsui_description_1wepg_mrt2a_94",
  "label": "awsui_label_1wepg_mrt2a_95",
  "outline": "awsui_outline_1wepg_mrt2a_103",
  "show-outline": "awsui_show-outline_1wepg_mrt2a_106",
  "native-input": "awsui_native-input_1wepg_mrt2a_110",
  "wrapper": "awsui_wrapper_1wepg_mrt2a_114",
  "label-wrapper": "awsui_label-wrapper_1wepg_mrt2a_120",
  "empty-content": "awsui_empty-content_1wepg_mrt2a_131",
  "description-bottom-padding": "awsui_description-bottom-padding_1wepg_mrt2a_141",
  "label-disabled": "awsui_label-disabled_1wepg_mrt2a_149",
  "description-disabled": "awsui_description-disabled_1wepg_mrt2a_150",
  "control": "awsui_control_1wepg_mrt2a_155"
};
  